import { _styled } from "i18n";

const OneTeamTaggingDisclaimer = () => {
	return (
		<div className="ott-disclaimer">
			<span className="ott-disclaimer__icon">i</span>
			<span>
				{_styled("gamePage.ott.disclaimer", {
					b: (chunks: string) => <strong key={chunks}>{chunks}</strong>,
				})}
			</span>
		</div>
	);
};

export default OneTeamTaggingDisclaimer;
